import React, { useState, useMemo } from 'react';
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent
} from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { useNavigate } from 'react-router-dom';
import { mockUsers } from '../../data/mockData';
import VisibilityIcon from '@mui/icons-material/Visibility';

const UserTable: React.FC = () => {
  const navigate = useNavigate();
  const [roleFilter, setRoleFilter] = useState<string>('Todos');

  const handleFilterChange = (event: SelectChangeEvent) => {
    setRoleFilter(event.target.value);
  };

  const filteredUsers = useMemo(() => {
    if (roleFilter === 'Todos') {
      return mockUsers;
    }
    return mockUsers.filter(user => user.role === roleFilter);
  }, [roleFilter]);

  const columns: GridColDef[] = [
    {
      field: 'name',
      headerName: 'Nombre',
      flex: 1,
      minWidth: 200
    },
    {
      field: 'email',
      headerName: 'Email',
      flex: 1,
      minWidth: 250
    },
    {
      field: 'role',
      headerName: 'Rol',
      width: 150
    },
    {
      field: 'expertise',
      headerName: 'Especialidad',
      width: 180,
      valueGetter: (params: any) => params || '-'
    },
    {
      field: 'actions',
      headerName: 'Acciones',
      width: 150,
      sortable: false,
      renderCell: (params) => (
        <Button
          variant="contained"
          size="small"
          startIcon={<VisibilityIcon />}
          onClick={() => navigate(`/perfil/${params.row.id}`)}
        >
          Ver Perfil
        </Button>
      )
    }
  ];

  return (
    <Box>
      <Box sx={{ mb: 3 }}>
        <FormControl sx={{ minWidth: 200 }}>
          <InputLabel>Filtrar por Rol</InputLabel>
          <Select
            value={roleFilter}
            label="Filtrar por Rol"
            onChange={handleFilterChange}
          >
            <MenuItem value="Todos">Todos</MenuItem>
            <MenuItem value="Emprendedor">Emprendedor</MenuItem>
            <MenuItem value="Mentor">Mentor</MenuItem>
            <MenuItem value="Admin">Admin</MenuItem>
          </Select>
        </FormControl>
      </Box>
      <Box sx={{ height: 600, width: '100%' }}>
        <DataGrid
          rows={filteredUsers}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: { pageSize: 10 }
            }
          }}
          pageSizeOptions={[5, 10, 25]}
          disableRowSelectionOnClick
          sx={{
            backgroundColor: 'white',
            '& .MuiDataGrid-cell:hover': {
              color: 'primary.main'
            }
          }}
        />
      </Box>
    </Box>
  );
};

export default UserTable;
